const AndroidIcon = ({ color = "var(--text-color-card)", height = 16, width = 16 }) => {
  return (
    <svg
      height={height}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 35 35"
      id="android">
      <path
        fill={color}
        d="M31.51,28h-28a3.17,3.17,0,0,1-2.36-1.09A3.63,3.63,0,0,1,.28,24.1C1.48,14.76,8.88,7.72,17.5,7.72s16,7,17.22,16.38a3.63,3.63,0,0,1-.85,2.84A3.17,3.17,0,0,1,31.51,28Zm-14-17.81c-7.37,0-13.7,6.11-14.74,14.2a1.12,1.12,0,0,0,.25.87.64.64,0,0,0,.48.24h28a.64.64,0,0,0,.48-.24,1.12,1.12,0,0,0,.25-.87C31.2,16.33,24.87,10.22,17.5,10.22Z"></path>
      <path
        fill={color}
        d="M27.38 12.74a1.17 1.17 0 0 1-.6-.16 1.24 1.24 0 0 1-.5-1.69l1.77-3.27a1.25 1.25 0 1 1 2.2 1.2l-1.77 3.26A1.26 1.26 0 0 1 27.38 12.74zM7.68 12.74a1.26 1.26 0 0 1-1.1-.66L4.81 8.82A1.25 1.25 0 1 1 7 7.62l1.77 3.27a1.25 1.25 0 0 1-.5 1.69A1.2 1.2 0 0 1 7.68 12.74zM10.79 20.7a1.88 1.88 0 0 0 0-3.75 1.88 1.88 0 0 0 0 3.75zM24.05 20.78a1.88 1.88 0 0 0 0-3.75 1.88 1.88 0 0 0 0 3.75z"></path>
    </svg>
  );
};

export default AndroidIcon;
